import { StoriesCrop, StoriesDownload, StoriesDraw, StoriesSticker, StoriesText } from '../../../../assets/images';

const ToolBar = ({ activeTool = null, handleToolClick, onDone, onCancel }) => {
    return (
        <>
            {activeTool === null ? (
                <div className="stories-editing-tools">
                    <button
                        className={activeTool === 'crop' ? 'se-active' : ''}
                        type="button"
                        aria-label="Crop"
                        onClick={() => handleToolClick('crop')}
                    >
                        <StoriesCrop />
                    </button>
                    <button
                        className={activeTool === 'text' ? 'se-active' : ''}
                        type="button"
                        aria-label="Add Text"
                        onClick={() => handleToolClick('text')}
                    >
                        <StoriesText />
                    </button>
                    <button
                        className={activeTool === 'emoji' ? 'se-active' : ''}
                        type="button"
                        aria-label="Emoji / Sticker"
                        onClick={() => handleToolClick('emoji')}
                    >
                        <StoriesSticker />
                    </button>
                    <button
                        className={activeTool === 'draw' ? 'se-active' : ''}
                        type="button"
                        aria-label="Draw"
                        onClick={() => handleToolClick('draw')}
                    >
                        <StoriesDraw />
                    </button>
                    <button
                        className={activeTool === 'download' ? 'se-active' : ''}
                        type="button"
                        aria-label="Download"
                        onClick={() => handleToolClick('download')}
                    >
                        <StoriesDownload />
                    </button>
                </div>
            ) : (
                <div className="stories-editing-actions">
                    <button type="button" className="se-btn-cancel" onClick={onCancel}>
                        Reset
                    </button>
                    <button type="button" className="se-btn-apply" onClick={onDone}>
                        Done
                    </button>
                </div>
            )}
        </>
    );
};

export default ToolBar;
